import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './ResetPasswordPopupOLD.rt';
import {resetPassword, changePassword} from '../../actions/resetPassword';

const mapStateToProps = (state) => ({
  resetPasswordSuccess: state.resetPassword.resetPasswordSuccess,
  changePasswordSuccess: state.resetPassword.changePasswordSuccess
});

const mapDispatchToProps = {resetPassword, changePassword};

class ResetPasswordPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      firstLoad: true,
      password: '',
      confirmPassword: '',
      showPopup: props.showPopup || false,
      changePasswordSuccess: this.props.changePasswordSuccess,
      resetPasswordSuccess: this.props.resetPasswordSuccess
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showPopup && this.state.firstLoad) {
      this.setState({
        firstLoad: false,
        showPopup: true,
        user: nextProps.user,
        changePasswordSuccess: false,
        resetPasswordSuccess: false
      })
    }
    else if (!nextProps.showPopup) {
      this.setState({
        firstLoad: true,
        showPopup: false
      })
    }

    if (nextProps.changePasswordSuccess !== this.props.changePasswordSuccess) {
      this.setState({changePasswordSuccess: nextProps.changePasswordSuccess});
    }

    if (nextProps.resetPasswordSuccess !== this.props.resetPasswordSuccess) {
      this.setState({resetPasswordSuccess: nextProps.resetPasswordSuccess});
    }
  }

  handlePasswordInputChange = (password) => {
    this.setState({
      password,
      error: !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password) &&
        'Error: password must be at least 8 characters, 1 alphabet and 1 number'
    });
  }

  handleConfirmPasswordChange = (confirmPassword) => {
    this.setState({
      confirmPassword
    });
    this.handleCheckPasswords(confirmPassword);
  }

  handleCheckPasswords = (confirmPassword) => {
    if (this.state.password !== confirmPassword) {
      this.setState({
        error: 'Error: The passwords you have entered do not match.'
      });
    } else {
      this.setState({
        error: null
      });
    }
  }

  handleResetPassword = () => {
    this.props.resetPassword({
      userID: this.state.user.id
    });
  }

  handleChangePassword = () => {
    if (this.state.error) return;
    this.props.changePassword({
      customerId: this.state.user.id,
      password: this.state.password,
      confirmationPassword: this.state.confirmPassword
    })
  }

  handleClose = () => {
    this.setState({
      firstLoad: true,
      showPopup: false,
      password: '',
      confirmPassword: '',
      error: null
    })
    this.props.handleClosePopup(this.props.popupName);
  }

  render = template;
}

ResetPasswordPopup.propTypes = {
  showPopup: PropTypes.bool,
  user: PropTypes.object,
  handleClosePopup: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPopup);
